import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// Storage key for intended destination
const REDIRECT_KEY = 'fs_auth_redirect';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      // Store the intended destination before redirecting to login
      const currentPath = location.pathname + location.search;
      if (currentPath !== '/login' && currentPath !== '/register' && currentPath !== '/') {
        sessionStorage.setItem(REDIRECT_KEY, currentPath);
      }

      // Redirect to login
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, isInitialized, location, navigate]);

  // Show loader while checking authentication
  if (!isInitialized) {
    return <Loader />;
  }

  // Not authenticated - will redirect via useEffect
  if (!isAuthenticated) {
    return <Loader />;
  }

  // Authenticated - render children
  return children;
}

AuthGuard.propTypes = { children: PropTypes.node };

// Helper function to get and clear stored redirect path
export function getStoredRedirectPath() {
  const path = sessionStorage.getItem(REDIRECT_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  return path;
}
